import useWindowDimensions from "Util/useWindowDimensions";

export const MOBILE_BREAKPOINT = 768;

export default function useIsMobile() {
  const { width } = useWindowDimensions();
  return width < MOBILE_BREAKPOINT;
}
